import { ReactComponent as Complete } from './complete.svg';

export default Complete;
